import {TypeExportAnalyseFinanciere} from "../../../enums/facturation/client/type-export-analyse-financiere";

export class FilterExportAnalyseFinanciere {
    dateDebut: Date;
    dateFin: Date;
    idsUniteDeProduction: number[];
    idsPointDeLivraison: number[];
    idsPointDeFacturation: number[];
    idsPrestation: number[];
    idsRegime: number[];
    idsRepas: number[];
    type: TypeExportAnalyseFinanciere;
}
